module.exports = __webpack_public_path__ + "img/logo7.46341437.png";